<template>
  <div>
    <v-row>
      <v-col>
        <Avatar :size="avatarSize" :userProfile="user.userProfile" v-if="user && user.userProfile && !imageUploading && !updatingUserProfile" />
        <v-avatar :size="avatarSize" v-else-if="imageUploading || updatingUserProfile" color="lightBackground">
          <v-progress-circular indeterminate />
        </v-avatar>
        <v-icon :size="avatarSize" v-else>mdi-account-circle</v-icon>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <MediaObjectUpload
          :requirements="{ minHeight: MIN_IMAGE_HEIGHT, minWidth: MIN_IMAGE_WIDTH }"
          :addText="$t('chapter.image.addImage')"
          :changeText="$t('chapter.image.changeImage')"
          @error="addImageErrorMessage"
          @loading="imageUploading = $event"
          @newId="newMediaId"
          :errorTooLargeMessage="
            $t('register.imageTooLarge', {
              maxImageSize: MAX_IMAGE_UPLOAD_MEGABYTES,
            })
          "
          :maxSizeBytes="MAX_IMAGE_UPLOAD_BYTES"
          :formats="IMAGE_FORMATS"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="text-left" cols="12">
        <span class="error-text">{{ imageErrorMessage }}</span>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import hasLoggedInUser from "@/mixins/hasLoggedInUser";
import MediaObjectUpload from "@/components/MediaObjectUpload";
import Avatar from "@/components/User/Avatar";
import {
  MIN_IMAGE_HEIGHT,
  MIN_IMAGE_WIDTH,
  MAX_IMAGE_UPLOAD_BYTES,
  MAX_IMAGE_UPLOAD_MEGABYTES,
  IMAGE_FORMATS,
} from "@/const";
import gql from "graphql-tag";
export default {
  mixins: [hasLoggedInUser],
  components: {
    MediaObjectUpload,
    Avatar,
  },
  data() {
    return {
      imageUrl: "",
      imageUploading: false,
      updatingUserProfile: false,
      imageErrorMessage: "",
    };
  },
  computed: {
    avatarSize() {
      return 120;
    },
    MIN_IMAGE_HEIGHT() {
      return MIN_IMAGE_HEIGHT;
    },
    MIN_IMAGE_WIDTH() {
      return MIN_IMAGE_WIDTH;
    },
    MAX_IMAGE_UPLOAD_BYTES() {
      return MAX_IMAGE_UPLOAD_BYTES;
    },
    MAX_IMAGE_UPLOAD_MEGABYTES() {
      return MAX_IMAGE_UPLOAD_MEGABYTES;
    },
    IMAGE_FORMATS() {
      return IMAGE_FORMATS;
    },
  },
  methods: {
    newMediaId(id) {
      this.updatingUserProfile = true;
      this.$apollo.mutate({
        mutation: gql`
          mutation($id: ID!, $mediaObjectId: String) {
            updateUserProfile(input: { id: $id, image: $mediaObjectId } ) {
              userProfile {
                id
                image {
                  id
                  contentUrl
                }
              }
            }
          }
        `,
        variables: {
          id: this.user.userProfile.id,
          mediaObjectId: id,
        },
        update: () => {
          this.updatingUserProfile = false;
        },
      });
    },
    addImageErrorMessage(message) {
      this.imageErrorMessage = message;
    },
  }
}
</script>